import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'
import { http } from '@/store/store.js'

// Containers
import Full from '@/containers/Full'

// Views
import Login from '@/views/pages/Login'

import Dashboard from '@/views/Dashboard'
import TempPage from '@/views/pages/TempPage' // 임시페이지로 활용

// 회원관리
// import UserManagement from '@/views/user/UserManagement'
import UserManagementList from '@/views/user/userList/UserManagementList' // 회원 목록
import UserManagementDetail from '@/views/user/userDetail/userManagementDetail' // 회원 상세

import CompanyUserManagementList from '@/views/user/companyUserList/CompanyUserManagementList'  // 기업회원 목록
import CompanyUserManagementDetail from '@/views/user/companyUserList/CompanyUserManagementDetail' // 기업회원 상세

// import UserDetail from '@/views/user/UserDetail_1'
// import RPointManagement from '@/views/user/RPointManagement'

// 계정회원관리
// import AuthUserManageList from '@/views/user/AuthUserManageList'

// 콘텐츠관리
// import ReportManagementList from '@/views/contents/ReportManagementList'
// import ReportManagementInfo from '@/views/contents/ReportManagementInfo'
// import ReportManagementForm from '@/views/contents/ReportManagementForm'
import ReportList from '@/views/contents/ContentsList' //콘텐츠 리스트
import ContentsForm from '@/views/contents/ContentsForm' //콘텐츠 등록폼
import ContentsEditForm from '@/views/contents/ContentsForm' //콘텐츠 수점폼

import ExtReportManagementList from '@/views/contents/extReport/ExtReportManagementList';
import ExtNewsManagementList from '@/views/contents/extNews/ExtNewsManagementList';
import ExtSiteManagementList from '@/views/contents/extSite/ExtSiteManagementList';

// 리포트 서베이 관리
import ReportSurveyManagementList from '@/views/contents/reportSurvey/ReportSurveyManagementList' //리포트 서베이 관리
import ReportSurveyForm from '@/views/contents/reportSurvey/ReportSurveyForm'

// 상품관리 > 이벤트패키지 관리
import AnnualReportList from '@/views/product/AnnualReportList' // 이벤트패키지
import AnnualReportInfo from '@/views/product/AnnualReportInfo' // 이벤트패키지 정보
import AnnualReportForm from '@/views/product/AnnualReportForm' // 이벤트패키지 등록,수정

// 상품관리 > 종합보고서 관리
import SynthesisReportList from '@/views/product/SynthesisReportList' // 종합보고서
import SynthesisReportInfo from '@/views/product/SynthesisReportInfo' // 종합보고서 정보
import SynthesisReportForm from '@/views/product/SynthesisReportForm' // 종합보고서 등록,수정

// 상품관리 > 계정 상품 관리
import UserAuthPermissionList from '@/views/product/UserAuthPermissionList' // 계정상품
import UserAuthPermissionInfo from '@/views/product/UserAuthPermissionInfo' // 계정상품 정보
import UserAuthPermissionForm from '@/views/product/UserAuthPermissionForm' // 계정상품 등록,수정

// 주문관리 > 보고서상품 주문관리
import OrderProductList from '@/views/order/OrderProductList'
import OrderProductInfo from '@/views/order/OrderProductInfo'
import OrderProductForm from '@/views/order/OrderProductForm'

// 주문관리 > 권한상품 주문관리
import OrderUserAuthList from '@/views/order/OrderUserAuthList'
import OrderUserAuthInfo from '@/views/order/OrderUserAuthInfo'
import OrderUserAuthForm from '@/views/order/OrderUserAuthForm'

// import ReportManagementInfo from '@/views/contents/ReportManagementInfo'
// import ReportManagementForm from '@/views/contents/ReportManagementForm'

// 대시보드(메인) 관리 > 메인관리
import MainManagementForm from '@/views/main/MainManagementForm'
import MainManagementList from '@/views/main/MainManagementList'

// 대시보드(메인) 관리 > 배너관리
// import BannerManagementForm from '@/views/main/BannerManagementForm'
import BannerManagement from '@/views/main/BannerManagement'

// 사이트 관리 > 메인페이지 진열 관리
import MainManagement from '@/views/site/main/MainManagement'
import KeyVisualManagementForm from '@/views/site/main/component/keyvisual/KeyVisualManagementForm' // 키비주얼 관리 상세
import CurationManagementForm from '@/views/site/main/component/curation/CurationManagementForm' // 큐레이션 관리 상세
import Banner01ManagementForm from '@/views/site/main/component/banner01/Banner01ManagementForm' // 배너1 관리 상세
import Banner02ManagementForm from '@/views/site/main/component/banner02/Banner02ManagementForm' // 배너2 관리 상세
import Banner03ManagementForm from '@/views/site/main/component/banner03/Banner03ManagementForm' // 배너3 관리 상세


// 사이트 관리 > 팝업관리
import PopUpManagement from '@/views/site/popup/PopUpManagement'
import PopUpManagementForm from '@/views/site/popup/PopUpManagementForm'


import SearchManagement from '@/views/site/search/SearchManagement'

import TermsManagement from '@/views/site/terms/TermsManagement'
import TermsForm from '@/views/site/terms/component/TermsForm'

import MnNoticeManagement from "@/views/notice/NoticeManagement";
import MnNoticeForm from "@/views/notice/component/NoticeForm";

// 레터관리 > 뉴스레터 관리
import NewsLetterList from '@/views/letter/NewsLetterList'
import NewsLetterInfo from '@/views/letter/NewsLetterInfo'
import NewsLetterForm from '@/views/letter/NewsLetterForm'

// 공통관리
import CodeManagement from '@/views/common/CodeManagement'
import MenuManagement from '@/views/common/MenuManagement'
import ManagerManagement from '@/views/common/ManagerManagement'
import PrivacyManagement from '@/views/common/PrivacyManagement'
import LoginLogManagement from '@/views/common/LoginLogManagement'

// 쿠폰관리
import CouponManagement from '@/views/coupon/CouponManagement'


// 공지사항 관리
import NoticeList from '@/views/customer/NoticeList'
import NoticeInfo from '@/views/customer/NoticeInfo'
import NoticeForm from '@/views/customer/NoticeForm'

// 고객센터 관리
import QAManager from '@/views/customer/QAManager'
import QAManagerInfo from '@/views/customer/QAManagerInfo'
import QAManagerForm from '@/views/customer/QAManagerForm'
import QAManagerPublic from '@/views/customer/QAManagerPublic'
import ReportRequestPublic from '@/views/customer/ReportRequestPublic'
import ReportRequestInfo from '@/views/customer/ReportRequestInfo'
import ReportRequestForm from '@/views/customer/ReportRequestForm'
import FAQManager from '@/views/customer/FAQManager'
import FAQManagerInfo from '@/views/customer/FAQManagerInfo'
import FAQManagerForm from '@/views/customer/FAQManagerForm'
import JoinGuide from '@/views/customer/JoinGuide'
import JoinGuideInfo from '@/views/customer/JoinGuideInfo'
import JoinGuideForm from '@/views/customer/JoinGuideForm'
import QATemplateList from '@/views/customer/QATemplateList'
import QATemplateForm from '@/views/customer/QATemplateForm'
import QATemplateInfo from '@/views/customer/QATemplateInfo'

// 통계 관리
import ContentStatistics from '@/views/statistics/content/ContentStatistics.vue' // -- 콘텐츠 통계(일반)
import ContentStatisticsInfo from '@/views/statistics/content/ContentStatisticsInfo.vue' // -- 콘텐츠 통계 상세정보(일반)

import ContentArStatistics from '@/views/statistics/content/ContentArStatistics.vue' // -- 콘텐츠 통계(스페셜)
import ContentArStatisticsInfo from '@/views/statistics/content/ContentArStatisticsInfo.vue' // -- 콘텐츠 통계 상세정보(스페셜)

import SalesStatistics from '@/views/statistics/sales/SalesStatistics.vue'

import UserStatistics from '@/views/statistics/user/UserStatistics.vue'
import ExtSiteStatistics from '@/views/statistics/extsite/ExtSiteStatistics.vue'

import { path } from 'chromedriver'
import swal from "sweetalert2";

Vue.use(Router)


const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'temp',
          redirect: '/temp/page',
          name: 'Temp',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'page',
              name: 'TempPage',
              component: TempPage
            }
          ]
        },
        {
          path: 'user',
          redirect: '/user/manage',
          name: '회원관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: '전체회원',
              component: UserManagementList
            },
            {
              path: 'detail',
              name: '회원상세정보',
              component: UserManagementDetail
            },
            // {
            //   path: 'rpoint',
            //   name: 'RPoint관리',
            //   component: RPointManagement
            // },
            //계정회원관리
            // {
            //   path: 'authusermanage',
            //   name: '계정 관리',
            //   component: AuthUserManageList
            // },
            // 기업회원 관리
            {
              path: 'companyusermanage',
              name: '구독회원',
              component: CompanyUserManagementList
            },
            {
              path: 'companyusermanagedetail',
              name: '구독회원',
              component: CompanyUserManagementDetail
            },

            // {
            //   path: ':reporturltype/info',
            //   name: '리포트 정보',
            //   component: ReportManagementInfo
            // },
            // {
            //   path: ':reporturltype/form',
            //   name: '리포트 등록',
            //   component: ReportManagementForm
            // }
          ]
        },
        // /contents/trendbrief
        {
          path: 'contents',
          redirect: '/contents/list',
          name: '콘텐츠관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            // {
            //   path: ':reporturltype',
            //   name: '콘텐츠 리스트',
            //   component: ReportManagementList
            // },
            // {
            //   path: ':reporturltype/info',
            //   name: '리포트 정보',
            //   component: ReportManagementInfo
            // },
            // {
            //   path: ':reporturltype/form',
            //   name: '리포트 등록',
            //   component: ReportManagementForm
            // },
            {
              path: 'list',
              name: 'DMC보고서',
              component: ReportList
            }, {
              path: 'form',
              name: 'DMC보고서 등록',
              component: ContentsForm
            }, {
              path: 'editForm',
              name: 'DMC보고서 수정',
              component: ContentsEditForm
            }, {
              path: 'extList',
              name: '외부 보고서',
              component: ExtReportManagementList
            }, {
              path: 'extNews',
              name: '외부 뉴스',
              component: ExtNewsManagementList
            },
            {
              path: 'extSiteSettings',
              name: '외부수집 설정',
              component: ExtSiteManagementList
            },
            {
              path: 'reportSurveyManagement',
              name: '리포트 서베이 관리',
              component: ReportSurveyManagementList
            },
            {
              path: 'reportSurvey/form',
              name: '리포트 서베이 등록',
              component: ReportSurveyForm
            }
          ]
        },
        {
          path: 'product',
          redirect: '/product/annualreport',
          name: '상품관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'annualreport',
              name: '패키지',
              component: AnnualReportList
            },
            {
              path: 'annualreport/info',
              name: '패키지 정보',
              component: AnnualReportInfo
            },
            {
              path: 'annualreport/form',
              name: '패키지 등록',
              component: AnnualReportForm
            },
            {
              path: 'synthesisreport',
              name: '종합보고서',
              component: SynthesisReportList
            },
            {
              path: 'synthesisreport/info',
              name: '종합보고서 정보',
              component: SynthesisReportInfo
            },
            {
              path: 'synthesisreport/form',
              name: '종합보고서 등록',
              component: SynthesisReportForm
            },
            {
              path: 'userauthpermission',
              name: '구독상품',
              component: UserAuthPermissionList
            },
            {
              path: 'userauthpermission/info',
              name: '구독상품 정보',
              component: UserAuthPermissionInfo
            },
            {
              path: 'userauthpermission/form',
              name: '구독상품 등록',
              component: UserAuthPermissionForm
            }
          ]
        },
        {
          path: 'common',
          redirect: '/common/code',
          name: '공통관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'code',
              name: '코드',
              component: CodeManagement
            },
            // {
            //   path: 'menu',
            //   name: '메뉴',
            //   component: MenuManagement
            // },
            {
              path: 'manager',
              name: '관리자',
              component: ManagerManagement
            },
            {
              path: 'privacy',
              name: '개인정보접근이력',
              component: PrivacyManagement
            },
            {
              path: 'loginlog',
              name: '로그인 이력',
              component: LoginLogManagement
            }
          ]
        },
        {
          path: 'order',
          redirect: '/order/product',
          name: '주문관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'product',
              name: '보고서상품 주문',
              component: OrderProductList
            },
            {
              path: 'product/info',
              name: '보고서상품 주문정보',
              component: OrderProductInfo
            },
            {
              path: 'product/form',
              name: '보고서상품 주문등록',
              component: OrderProductForm
            },
            {
              path: 'userAuth',
              name: '구독회원 주문',
              component: OrderUserAuthList
            },
            {
              path: 'userAuth/info',
              name: '구독회원 주문정보',
              component: OrderUserAuthInfo
            },
            {
              path: 'userAuth/form',
              name: '구독회원 주문등록',
              component: OrderUserAuthForm
            },
            // {
            //   path: 'menu',
            //   name: '메뉴관리',
            //   component: MenuManagement
            // },
            // {
            //   path: 'manager',
            //   name: '관리자관리',
            //   component: ManagerManagement
            // }
          ]
        },
        {
          path: 'coupon',
          redirect: '/coupon/manage',
          name: '쿠폰관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: '쿠폰관리',
              component: CouponManagement
            },
          ]
        },
        {
          path: 'customer',
          redirect: '/customer/qamanager',
          name: '고객센터관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'notice',
              name: '공지사항',
              component: NoticeList
            },
            {
              path: 'notice/info',
              name: '공지사항 등록정보',
              component: NoticeInfo
            },
            {
              path: 'notice/form',
              name: '공지사항 등록',
              component: NoticeForm
            },
            {
              path: 'qamanager',
              name: '고객문의',
              component: QAManager
            },
            {
              path: 'qamanager/info',
              name: '고객문의 등록정보',
              component: QAManagerInfo
            },
            {
              path: 'qamanager/form',
              name: '고객문의 답변 등록',
              component: QAManagerForm
            },
            {
              path: 'qamanagerpublic',
              name: '고객문의',
              component: QAManagerPublic
            },
            {
              path: 'reportrequestpublic',
              name: '보고서 의뢰',
              component: ReportRequestPublic
            },
            {
              path: 'reportrequest/info',
              name: '보고서 의뢰 답변 정보',
              component: ReportRequestInfo
            },
            {
              path: 'reportrequest/form',
              name: '보고서 의뢰 답변 등록',
              component: ReportRequestForm
            },
            {
              path: 'faqmanager',
              name: 'FAQ',
              component: FAQManager
            },
            {
              path: 'faqmanager/info',
              name: 'FAQ 정보',
              component: FAQManagerInfo
            },
            {
              path: 'faqmanager/form',
              name: 'FAQ 등록',
              component: FAQManagerForm
            },
            {
              path: 'joinguide',
              name: '회원가입안내',
              component: JoinGuide
            },
            {
              path: 'joinguide/info',
              name: '회원가입안내 정보',
              component: JoinGuideInfo
            },
            {
              path: 'joinguide/form',
              name: '회원가입안내 등록',
              component: JoinGuideForm
            },
            {
              path: 'qatemplate',
              name: '답변 템플릿',
              component: QATemplateList
            },
            {
              path: 'qatemplate/info',
              name: '답변 템플릿 정보',
              component: QATemplateInfo
            },
            {
              path: 'qatemplate/form',
              name: '답변 템플릿 등록',
              component: QATemplateForm
            },
          ]
        },
        {
          path: 'main',
          redirect: '/main/mainmanagement',
          name: '메인 관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'mainmanagement',
              name: '메인관리',
              component: MainManagementList
            },
            {
              path: 'mainmanagement/form',
              name: '메인관리 등록',
              component: MainManagementForm
            },
            {
              path: 'bannermanagement',
              name: '메인관리 등록',
              component: BannerManagement
            },
          ]
        },
        {
          path: 'site',
          redirect: '/site/mainmanagement',
          name: '사이트 관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'mainmanagement',
              name: '메인페이지',
              component: MainManagement
            },
            {
              path: 'keyvisualmanagement/form',
              name: '키비쥬얼 등록',
              component: KeyVisualManagementForm
            },
            {
              path: 'curationmanagement/form',
              name: '큐레이션 등록',
              component: CurationManagementForm
            },
            {
              path: 'banner01management/form',
              name: '배너1 등록',
              component: Banner01ManagementForm
            },
            {
              path: 'banner02management/form',
              name: '배너2 등록',
              component: Banner02ManagementForm
            },
            {
              path: 'banner03management/form',
              name: '배너3 등록',
              component: Banner03ManagementForm
            }
          ]
        },
        {
          path: 'site',
          redirect: '/site/popupmanagement',
          name: '사이트 관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: "popupmanagement",
              name: "팝업 ",
              component: PopUpManagement
            },
            {
              path: 'popupmanagement/form',
              name: '팝업 등록',
              component: PopUpManagementForm
            }
          ]
        },
        {
          path: 'site',
          redirect: '/site/searchmanagement',
          name: '사이트 관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: "searchmanagement",
              name: "통합검색",
              component: SearchManagement
            }
          ]
        },
        {
          path: 'site',
          redirect: '/site/termsmanagement',
          name: '사이트 관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: "termsmanagement",
              name: "약관",
              component: TermsManagement
            },
            {
              path: 'termsfrom/form',
              name: '약관 등록',
              component: TermsForm
            }
          ]
        },
        {
          path: 'letter',
          redirect: '/letter/newsletter',
          name: '레터관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'newsletter',
              name: '뉴스레터',
              component: NewsLetterList
            },
            {
              path: 'newsletter/info',
              name: '뉴스레터 등록정보',
              component: NewsLetterInfo
            },
            {
              path: 'newsletter/form',
              name: '뉴스레터 등록',
              component: NewsLetterForm
            },
          ]
        },
        {
          path: 'statis',
          redirect: '/statis/userStatistics',
          name: '통계관리',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'userStatistics',
              name: '회원통계',
              component: UserStatistics
            },
            {
              path: 'contentStatistics',
              name: '콘텐츠통계(일반)',
              component: ContentStatistics
            },
            {
              path: 'contentStatistics/info',
              name: '콘텐츠통계 상세정보(일반)',
              component: ContentStatisticsInfo
            },
            {
              path: 'contentArStatistics',
              name: '콘텐츠통계(스페셜)',
              component: ContentArStatistics
            },
            {
              path: 'contentArStatistics/info',
              name: '콘텐츠통계 상세정보(스페셜)',
              component: ContentArStatisticsInfo
            },
            {
              path: 'salesStatistics',
              name: '매출통계',
              component: SalesStatistics
            },
            {
              path: 'extSiteStatistics',
              name: '외부수집 통계',
              component: ExtSiteStatistics
            },
          ]
        },
        {
          path: 'manager',
          redirect: '/manager/noticemanagement',
          name: '관리자 공지사항',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'noticemanagement',
              name: '관리자 공지사항',
              component: MnNoticeManagement
            },
            {
              path: 'noticeform/form',
              name: '관리자 공지사항 등록',
              component: MnNoticeForm
            },
          ]
        },
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/Login',
      name: 'Login Root',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/pages/login') {
    // 엑세스 토큰이 살아있는지 체크하는 로직
    const token = sessionStorage.getItem("myToken");
    
    if (!token || token === "null") {
      // 토큰이 없으면 로그인 페이지로 이동
      return next({ path: '/pages/login' });
    }

    const params = 'token=' + token;

    // axios를 사용하여 토큰 검증
    http.post('/oauth/check_token', params, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded',
        'Authorization': store.getters.getCredentialCode
      }
    })
    .then(() => {
      // 토큰이 유효하면 계속 진행
      next();
    })
    .catch((error) => {
      // 토큰이 유효하지 않으면 로그인 페이지로 이동
      console.error('Token validation failed:', error);
      sessionStorage.removeItem("myToken");
      sessionStorage.removeItem("tokenExpiry");
      swal.fire({
        type: 'error',
        title: '다른 곳에서 로그인하여 현재 세션이 종료되었습니다.',
        showConfirmButton: false,
        timer: 1500
      });
      next({ path: '/pages/login' });
    });
  } else {
    next();
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js